import { render, staticRenderFns } from "./ChangeLogModal.vue?vue&type=template&id=21276760&scoped=true&"
import script from "./ChangeLogModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeLogModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeLogModal.vue?vue&type=style&index=0&id=21276760&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21276760",
  null
  
)

export default component.exports